module.exports = __webpack_public_path__ + "img/aiAssistanceIcon.bfa1e1ea.svg";